









import MoreButton from '@/components/parts/catalog/list/item/components/More.vue';
import { AppHeading, ListCardBadge, AppPicture } from '@/uikit';
export default {
  components: {
    AppHeading,
    MoreButton,
    AppPicture,
    ListCardBadge,
  },
  props: {
    routeName: {
      type: String,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      default: 'no name',
    },
    image: {},
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/event/card/components/MiniCard.vue